import React from 'react';
import { Table, Card, Spinner } from 'react-bootstrap';

/**
 * Standard Data Table component
 * @param {Array} headers - Array of { label, key, sortable, align, width }
 * @param {Array} data - The data to display
 * @param {Boolean} loading - Loading state
 * @param {Function} renderRow - Function to render each row (item, index)
 * @param {String} emptyMessage - Message to show when no data
 * @param {String} sortBy - Current sort key
 * @param {String} sortOrder - Current sort order (asc/desc)
 * @param {Function} onSort - Handler for sortable header clicks
 */
const DataTable = ({ 
  headers = [], 
  data = [], 
  loading = false, 
  renderRow, 
  emptyMessage = "No data found.",
  sortBy,
  sortOrder,
  onSort,
  className = ""
}) => {
  return (
    <Card className={`shadow-sm border-0 ${className}`}>
      <div className="table-responsive">
        <Table hover className="mb-0">
          <thead className="thead-light">
            <tr>
              {headers.map((header, idx) => (
                <th 
                  key={idx}
                  onClick={() => header.sortable && onSort && onSort(header.key)}
                  style={{ 
                    cursor: header.sortable ? 'pointer' : 'default',
                    width: header.width || 'auto',
                    minWidth: header.width || 'auto',
                    textAlign: header.align || 'left'
                  }}
                  className={header.align === 'right' ? 'text-right' : ''}
                >
                  {header.label}
                  {header.sortable && sortBy === header.key && (
                    <span className="ml-1">
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={headers.length} className="text-center py-5">
                  <Spinner animation="border" variant="primary" size="sm" className="mr-2" />
                  <span className="text-muted small">Loading data...</span>
                </td>
              </tr>
            ) : data && data.length > 0 ? (
              data.map((item, idx) => renderRow(item, idx))
            ) : (
              <tr>
                <td colSpan={headers.length} className="text-center py-5 text-muted">
                  <i className="fas fa-inbox fa-2x mb-3 d-block opacity-50"></i>
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Card>
  );
};

export default DataTable;
